import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { logFCI } from "@/shared/lib/fci";

declare global {
    interface Window {
        unifiedTrackingInstance?: {
            trackUserBehavior: (eventName: string, payload: object) => void;
        };
    }
}

export const track = (eventName: string, payload: object) => {
    console.debug(eventName, payload);

    if (window.unifiedTrackingInstance) {
        window.unifiedTrackingInstance.trackUserBehavior(eventName, payload);
    } else {
        logFCI({ errorType: FCI_ERROR.Convenience, errorInfo: "UBE tracking: no tracking instance available" });
    }
};
